export const EmployeeTypes = {
  IEmployeeService: Symbol("IEmployeeService"),
};
